import Vue from "vue";
import router from "../setup/routing/router";
import store from "../setup/store/store.js";
import RouteView from "../pages/general/RouteView.vue";
import "Editor/theme.scss";

import "../setup/analytics.js";

import * as Sentry from "@sentry/browser";

import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import "../stylesheets/frontend-stylesheets.scss";

const opts = {
  theme: { disable: true }
};

Vue.use(Vuetify);

Vue.config.devtools = true;

function setVueEnv (store) {
  fetch("/api/config")
    .then(req => req.json())
    .then(data => {
      store.commit("setEnv", data);

      if (data.sentryClientDSN) {
        Sentry.init({
          dsn: data.sentryClientDSN,
          integrations: [
            new Sentry.Integrations.Vue({
              Vue,
              attachProps: true
            })
          ]
        });
      }
    });
}

setVueEnv(store);

/* eslint-disable-next-line no-new */
new Vue({
  el: "#designer-app",
  router,
  store,
  vuetify: new Vuetify(opts),
  render: createElement => createElement(RouteView)
});
